import firebase from "firebase/app";
import useSWR from "swr";

import "firebase/auth";
import "firebase/firestore";

/**
 * SPWN ユーザーに紐づく start.gg 連携情報。
 * 機密トークンは保持せず、突合に使う user.id と表示名だけを持つ。
 * Firestore の users/{uid}.startgg に保存する。
 */
export type StartggLink = {
  userId: string;
  username: string;
  linkedAt: number;
};

const userDoc = (uid: string) => firebase.firestore().doc(`users/${uid}`);

export const useStartggLink = () => {
  const uid = firebase.auth().currentUser?.uid ?? null;

  const swr = useSWR(uid ? ["startggLink", uid] : null, async () => {
    const snapshot = await userDoc(uid as string).get();
    const startgg = snapshot.data()?.startgg as StartggLink | undefined;
    return startgg ?? null;
  });

  const save = async (link: StartggLink): Promise<void> => {
    if (!uid) {
      throw new Error("not logged in");
    }
    await userDoc(uid).set({ startgg: link }, { merge: true });
    await swr.mutate();
  };

  return {
    link: swr.data ?? null,
    isLoading: swr.isLoading,
    reload: swr.mutate,
    save,
  };
};
